/** ----------------------------------------
    Interface
 ---------------------------------------- */

import { UserStore } from '@interface/store/User';

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {
    isLoggedIn: (state: UserStore) => !!state.token,
    fullName: (state: UserStore) => (state.data.lastname_prefix) ? `${ state.data.initials } ${ state.data.lastname_prefix } ${ state.data.lastname }` : `${ state.data.initials } ${ state.data.lastname }`,
    communityName: (state: UserStore) => (state.data.lastname_prefix) ? `${ state.data.lastname_prefix } ${ state.data.lastname }, ${ state.data.initials }` : `${ state.data.lastname }, ${ state.data.initials }`,
    initials: (state: UserStore) => (state.data.initials) ? `${ state.data.initials.charAt(0) }${ state.data.lastname.charAt(0) }` : '',
    salutation: (state: UserStore) => (state.data.gender === 0) ? 'mevrouw' : (state.data.gender === 1) ? 'meneer' : '',
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters
